package com.bikompanion.domain

data class StationWatch(
    val networkId: String,
    val stationId: String,
    val stationName: String,
    val bikeType: BikeType,
    val expiresAtEpochMillis: Long,
    val station: BikeStation? = null,
)
